import useAppState from '../../../context/AppContext';
import MgpButton from '../../../elements/MgpButton/MgpButton';
import { accessJsonAttr, getPriceOfOffer, isMobile } from '../../../utils/utils';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { EffectCoverflow, Navigation, Pagination } from 'swiper/modules';
import MgpMessage from '../../../elements/MgpMessage/MgpMessage';
import { IGarantie, IOptionCotisation } from '../../../context/model';

type GuarantyOfferFormComponentProps = {
    handleSwitchPage: () => void;
    garanties: IGarantie[];
    offers: IOptionCotisation[];
    offerCode: string;
    errors: any;
    handleChooseOffer: (e: any, code: string) => void;
}


export default function REGuarantyOfferFormComponent({handleSwitchPage, garanties, offers, offerCode, errors, handleChooseOffer}: Readonly<GuarantyOfferFormComponentProps>) {

  
  const {
    state: { updatedProposition, additionalData }
  } = useAppState();


  const style = {
    transform: 'scale(1.05)',
    gap: "30px",
    opacity: 1,
    border: "1px solid #DC0055",
    backgroundColor: 'rgba(220, 0, 85, .1)'
  };

  const styleAutre = {
    opacity: 0.6,
  };

  const recommendedOffer = offers.find(offer => offer.recommended)?.offerCode ?? "MIOM_ORPT1";

  return (            
    <form style={{width: '100%'}}>
      <p className='bleu fw-bold ta-center mb-md'>Renforcez votre offre santé parmi les garanties suivantes</p>
      {
        garanties.length === 0 && <MgpMessage type="danger" message='Les garanties non trouvées' hasCloseBtn={true}/>
      }
      {!isMobile() && garanties.length > 0 &&
        <div className="flex page-content va-center">
            {garanties.map((card, i) =>
              <div 
                className={`p-md card-selected box m-y-md card ${card.code === recommendedOffer && 'option-recommendee'}`} 
                key={i+1} 
                style={offerCode === card?.code ? style : (offerCode !== "" && offerCode !== card?.code) ? styleAutre : {}}>
                  {card.code === recommendedOffer ? <p className='ta-center fz-sm fushia box-title mb-md'>La plus adaptée à votre situation</p> : ""}
                  
                  <p className="fw-medium fz-lg mt-md mb-xs ta-center">{card.titre}</p>
                  <p className='fz-sm box-subTitle ta-center'>{card.subTitre}</p>
                  
                  <div className='box-content'>
                    {card.couvertures.map((el, i) => 
                      <p className='fz-sm' key={i+1}><i className='icon-coche fushia fz-xs pr-xs' /><span className='fz-sm' dangerouslySetInnerHTML={{ __html:  el.description }} /></p> 
                    )}
                    <p className='fz-sm m-y-sm '><span dangerouslySetInnerHTML={{__html : card.servicesInclusTexte}}/></p>
                  </div> 

                  <div className='m-x-lg m-y-sm ta-center'>
                    <span className="border-bleu light full mt-md"></span>
                  </div>
                  
                  <p className='bleu fw-medium ta-center fz-md'>Votre cotisation prévisionnelle*</p>
                

                  {(additionalData?.hasChild || additionalData?.hasPartner) ? 
                    <div>
                      <div className='ta-center'>
                        <p className='m-y-xs fz-lg fw-bold'>{getPriceOfOffer(offers, card.code)} / <span className='fz-sm fw-medium'>mois</span></p>
                      </div>
                    </div>
                    :
                    <div className='ta-center m-y-md'>
                      <p className=''><span className='fz-xs pr-xs'>Pour vous</span><span className='fz-lg fw-bold'>{getPriceOfOffer(offers, card.code)}  /</span><span className='fz-sm fw-medium'>mois</span></p> 
                    </div>
                  }

                  <p className='fz-xs m-y-sm ta-center'>*Sur la base des informations déclarées</p>
                  
                  <div className='ta-center'>
                    {offerCode === card.code ?
                      <MgpButton  type="button" text="C'est mon choix" color='bleu' size="small" icon="coche"/> :
                      <MgpButton  type="button" text="Choisir cette garantie" color='bleu' size="small"  onClick={(e: any) => handleChooseOffer(e, card.code)}/>
                    } 
                  </div>
              </div>
            )}
        </div>
      }

      {isMobile() && garanties.length > 0 &&
        <div className='grid-flex va-center jc-center'>        
        <Swiper
          effect={'coverflow'}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          initialSlide={updatedProposition?.offerCode ? garanties.findIndex(el => el.code === updatedProposition?.offerCode) : garanties.findIndex(el => el.garantieRecommandee)}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: false,
          }}
          pagination={true}
          modules={[EffectCoverflow, Pagination, Navigation]}
          className="mySwiper"
          
        >
          
          {garanties.map((card, i) =>
            <SwiperSlide key={i+1}>
              <div className={`shadow-noir card-mobile mb-lg p-xs bg-blanc ${card.garantieBase && 'option-base'} ${card.garantieRecommandee && 'option-recommendee'}`} key={i+1}>
                {card.garantieRecommandee ? <p className='ta-center fz-sm fushia box-title-mobile box-title'>La plus adaptée à votre situation</p> : ""}
                    
                  <p className="fw-medium fz-md mt-sm mb-xs pt-xs ta-center">{card.titre}</p>
                  <p className='fz-sm box-subTitle ta-center'>{card.subTitre}</p>

                  {card.couvertures.map((el, i) => 
                    <p className='fz-sm' key={i+1}><i className='icon-coche fushia fz-xs' /><span className='fz-sm' dangerouslySetInnerHTML={{ __html:  el.description }} /></p> 
                  )}
                      
                  <p className='fz-sm m-y-sm fw-bold'>{card.servicesInclusTexte}</p> 
                  
                  <div className='m-x-sm ta-center'>
                    <span className="border-bleu light full m-y-xs"></span>
                  </div>

                  <p className='bleu fw-medium ta-center fz-md'>Votre cotisation*</p>
                  <p className='ta-center mb-xs fz-sm'>(hors cotisation obligatoire)</p>

                {(additionalData?.hasChild || additionalData?.hasPartner) ? 
                  <div>
                    <div className='ta-center'>
                      <p className='m-y-xs fz-lg fw-bold'>{getPriceOfOffer(offers, card.code)} / <span className='fz-sm fw-medium'>mois</span></p>
                    </div>
                  </div>
                  :
                  <div className='ta-center m-y-md'>
                    <p className=''><span className='fz-xs pr-xs'>Pour vous</span><span className='fz-lg fw-bold'>{getPriceOfOffer(offers, card.code)} /</span><span className='fz-sm fw-medium'>mois</span></p> 
                  </div>
                }

                  <p className='fz-xs m-y-sm ta-center'>*Sur la base des informations déclarées</p>

                  <div className='ta-center mb-sm'>
                    {offerCode === card.code ?
                      <MgpButton  type="button" text="C'est mon choix" color='bleu' size="small" icon="coche"/> :
                      <MgpButton  type="button" text="Choisir cette formule" color='bleu' size="small"  onClick={(e: any) => handleChooseOffer(e, card.code)}/>
                    } 
                  </div>       
              </div>
            </SwiperSlide>  
          )}
          
        </Swiper>
        </div>
      }
      
      {garanties.length > 1 &&
        <div className='m-y-sm pb-sm' style={garanties.length > 2 ? {textAlign:'center'} : {}}>
            {errors && accessJsonAttr(errors, 'offerCode') && <p className="fushia m-y-md fw-medium fz-md">(*) Veuillez choisir une offre ci-dessus.</p>}
            <button className='cta-blanc cta-small' onClick={() => handleSwitchPage()}>Comparer les garanties</button>
        </div>
      }
      
    </form>
  )
}
